












import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { PolicyBenefitTypeDTO } from "@/api/ClientPortalApiClient";

@Component({})
export default class CbxBenefitType extends Vue {
  private types: PolicyBenefitTypeDTO[] | null = [];
  private selectedType = new PolicyBenefitTypeDTO();

  $refs!: {
    selection: HTMLSelectElement;
  };

  public created() {
    this.getAvailableTypes();
  }

  public setSelected(type: PolicyBenefitTypeDTO | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  public typeSelected(type: PolicyBenefitTypeDTO) {
    this.$emit("benefitTypeSelected", type);
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .benefitType_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }

  public reset() {
    this.$refs.selection.selectedIndex = -1;
  }
}
